import { Case, Else, If, Switch, Then } from "react-if"
import { useSearchParams } from "react-router"
import AgentSignupForm from "../../components/forms/AgentSignupForm.component"
import { MantineProvider } from "@mantine/core"
import { theme } from "../../Theme"
import LeadSignupForm from "../../components/forms/LeadSignupForm.component"
import ApplicationSignupForm from "../../components/forms/ApplicationSignupForm.component"

export default function Form() {
    const [searchParams, setSearchParams] = useSearchParams()
    const params = Object.fromEntries(searchParams)

    return (
        <MantineProvider theme={theme}>
            <If condition={searchParams.has('client_number')}>
                <Then>
                    <If condition={searchParams.has('form_type')}>
                        <Then>
                            <If condition={searchParams.has('form_type') && searchParams.has('form_identifier')}>
                                <Then>
                                    <Switch>
                                        <Case condition={searchParams.get('form_type') === 'lead'}>
                                            <LeadSignupForm />
                                        </Case>
                                        <Case condition={searchParams.get('form_type') === 'agent'}>
                                            <AgentSignupForm />
                                        </Case>
                                        <Case condition={searchParams.get('form_type') === 'application'}>
                                            <ApplicationSignupForm />
                                        </Case>
                                    </Switch>
                                </Then>
                                <Else>
                                    <p>
                                        Form identifier is not defined! Please contact admin.
                                    </p>
                                </Else>
                            </If>
                        </Then>
                        <Else>
                            <p>
                                Form type is not defined! Please contact admin.
                            </p>
                        </Else>
                    </If>
                </Then>
                <Else>
                    <p>
                        Client number is not defined! Please contact admin.
                    </p>
                </Else>
            </If>
        </MantineProvider>
    )
}